export default "__VITE_ASSET__67d555e4__"